import {
  ExperienceMap,
  VARIATION_NAME_TO_KEY_MAP,
  VariationKey,
  type ExperienceResult,
  type RawConvertVariationKey,
  type VariationName,
} from './types';

export const getVariationKeyFromRawKey = (key: RawConvertVariationKey) => {
  const [_, ...variationKeyParts] = key.split('-');
  const variationKey = variationKeyParts.join('-');

  if (!isValidVariationKey(variationKey)) {
    console.error(`Variation key ${variationKey} is not a valid variation key`);
    return null;
  }
  return variationKey;
};

export const isValidVariationKey = (variationKey: string): variationKey is VariationKey => {
  return Object.values(VariationKey).includes(variationKey as VariationKey);
};

export const isValidExperienceId = (experienceId: string): experienceId is ExperienceMap => {
  return Object.values(ExperienceMap).includes(experienceId as ExperienceMap);
};

export const isExperienceActive = (
  experiences: ExperienceResult[] | undefined,
  experienceId: ExperienceMap,
  variationName: VariationName
): boolean => {
  return (
    experiences?.some(
      (exp) =>
        exp.id === experienceId && exp.variationKey === VARIATION_NAME_TO_KEY_MAP[variationName]
    ) ?? false
  );
};
